import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import useStoreHours from "./useStoreHours";
import Style from "../addStore.module.scss";

const StoreHours = ({ formik, getFieldError }) => {
  const {
    handleNext,
    handleCloseModal,
    handleTimeChange,
    daysOfWeek,
    handleToggle,
    getTimeValue,
    getStatus,
    // getMinToTime,
    // pickupTimeError,
  } = useStoreHours(formik);

  return (
    <>
      <div className="form-check form-switch pro-mb-4">
        <input
          className="form-check-input cursor-pointer"
          type="checkbox"
          role="switch"
          id="pick_up"
          name="pick_up"
          checked={Boolean(formik.values?.pick_up === 1) ?? false}
          onChange={(e) => {
            formik.setFieldValue("pick_up", e.target.checked ? 1 : 2);
          }}
        />
        <label htmlFor="pick_up" className="pro-check-label">
          Set Pickup Hour
        </label>
        {getFieldError("pick_up") && (
          <div className={`${Style.form_toggle_err_msg}`}>Please select at least one day's hours.</div>
        )}
      </div>

      {/* {formik.values?.pick_up === 1 && ( */}
        <>
          {daysOfWeek.map((day) => (
            <div
              key={day}
              className={`pro-d-flex pro-flex-column pro-mb-4 ${Style.time_wrap}`}
            >
              <label className="pro-font-sm pro-mb-1 pro-fw-medium">
                {day}
              </label>
              <div
                className={`pro-d-flex pro-items-center ${Style.time_picker_wrap}`}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={getTimeValue(day, "from") || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "from", newValue)
                    }
                    className="time-picker"
                    slotProps={{
                      actionBar: {
                        actions: ["clear", "accept"],
                        sx: {
                          "& .MuiButton-root:first-of-type": {
                            background: "none !important",
                            border: "none",
                            boxShadow: "none",
                            textTransform: "capitalize",
                            color: "var(--pro-primary) !important",
                            fontSize: "14px",
                            fontWeight: 600,
                            "&:hover": {
                              background: "none !important",
                              color: "var(--pro-primary-hover) !important",
                            },
                          },
                        },
                      },
                    }}
                    disabled={
                      getStatus(day)?.toString() === "2" ||
                      formik.values.pick_up?.toString() === "2"
                    }
                  />
                  <span className="pro-px-3 pro-d-flex pro-items-center">
                    <span className="material-symbols-outlined x4">
                      {" "}
                      remove{" "}
                    </span>
                  </span>

                  <TimePicker
                    value={getTimeValue(day, "to") || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "to", newValue)
                    }
                    className="time-picker"
                    // minTime={getMinToTime(day)}
                    disabled={
                      getStatus(day)?.toString() === "2" ||
                      formik.values.pick_up?.toString() === "2"
                    }
                    slotProps={{
                      actionBar: {
                        actions: ["clear", "accept"],
                        sx: {
                          "& .MuiButton-root:first-of-type": {
                            background: "none !important",
                            border: "none",
                            boxShadow: "none",
                            textTransform: "capitalize",
                            color: "var(--pro-primary) !important",
                            fontSize: "14px",
                            fontWeight: 600,
                            "&:hover": {
                              background: "none !important",
                              color: "var(--pro-primary-hover) !important",
                            },
                          },
                        },
                      },
                    }}
                  />
                  <div className="form-check form-switch pro-mb-0 pro-ms-auto">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id={`${day}-switch`}
                      checked={getStatus(day)?.toString() === "1" || false}
                      onChange={(e) => handleToggle(day, e.target.checked)}
                      disabled={formik.values.pick_up?.toString() === "2"}
                    />
                  </div>
                </LocalizationProvider>
              </div>
              {/* {pickupTimeError[day] !== null && (
                <span className="error pro-mt-2 pro-font-xs pro-lh-1">
                  {pickupTimeError[day]}
                </span>
              )} */}
            </div>
          ))}
          <div>
            <Input
              label={"Pickup Note"}
              type="text"
              id="pickup_note"
              name="pickup_note"
              className={`pro-input lg ${
                getFieldError("pickup_note") && " error"
              }`}
              {...formik.getFieldProps("pickup_note")}
              error={getFieldError("pickup_note")}
              errorMessage={getFieldError("pickup_note")}
              disabled={formik.values.pick_up?.toString() === "2"}
            />
          </div>
          <div className="pro-rtl">
            <Input
              label={"(ملاحظة صغيرة)  Pickup Note"}
              type="text"
              id="alias_pickup_note"
              name="alias_pickup_note"
              className={`pro-input lg ${
                getFieldError("alias_pickup_note") && " error"
              }`}
              {...formik.getFieldProps("alias_pickup_note")}
              error={getFieldError("alias_pickup_note")}
              errorMessage={getFieldError("alias_pickup_note")}
              disabled={formik.values.pick_up?.toString() === "2"}
            />
          </div>
        </>
      {/* )} */}
      <div className={`col-12 pro-d-flex pro-justify-end pro-mt-auto pro-pb-5`}>
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCloseModal}
          type="button"
        >
          Cancel
        </Button>
        <Button className={"pro-btn-primary lg pro-ms-3"} onClick={handleNext}>
          {"Next"}
        </Button>
      </div>
    </>
  );
};

export default StoreHours;
